module.exports = __webpack_public_path__ + "images/emoji/no_bell.b6d21e0cac9279e280b2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/no_bell.png
// module id = KuC0
// module chunks = 2